var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCanvasTooltip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 225 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "canvas-tooltip_svg__a",
    d: "M0 0h225v100H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "canvas-tooltip_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#canvas-tooltip_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.1,
    stroke: "currentColor",
    mask: "url(#canvas-tooltip_svg__b)",
    d: "M.5.5h224v99H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.55,
    stroke: "currentColor",
    mask: "url(#canvas-tooltip_svg__b)",
    d: "M11.5 11.5h30v49h-30zm41 0h30v49h-30zm41 0h30v49h-30z"
  }), /*#__PURE__*/React.createElement("circle", {
    strokeOpacity: 0.55,
    stroke: "currentColor",
    mask: "url(#canvas-tooltip_svg__b)",
    cx: 159,
    cy: 45,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 44.13l2.313 4.686 5.172.752-3.742 3.648.883 5.151L192 55.935l-4.626 2.432.883-5.151-3.742-3.648 5.172-.752L192 44.13zm-15-30.012l7.191 14.382h-14.382L177 14.118zM93.5 71.5h30v49h-30zm-82 0h71v49h-71zm123 0h30v49h-30z",
    strokeOpacity: 0.55,
    stroke: "currentColor",
    mask: "url(#canvas-tooltip_svg__b)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasTooltip);
export default __webpack_public_path__ + "static/media/canvas-tooltip.e0667da9.svg";
export { ForwardRef as ReactComponent };